import React from "react";
import "./Footer.css";
import { TranslationContext } from "./TranslationContext";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { translation } = React.useContext(TranslationContext);
  return (
    <div className="footer-container">
      <div className="footer-upperPart">
        <div className="horario-direccion">
          <div className="horario-container">
            <h1>{translation.timetable}</h1>
            <p>9:00 - 17:00 </p>
            <p>
              {translation.tue} {translation.closed}
            </p>
          </div>
          <div className="direccion-container">
            <h1>{translation.adress}</h1>
            <p>
              <a href="https://www.google.cz/maps/place/Barrio+Nieves,+2,+38700+Las+Nieves,+Santa+Cruz+de+Tenerife/@28.6943947,-17.7842949,17z/data=!3m1!4b1!4m6!3m5!1s0xc6beea36365060f:0x92cce2a1723306ae!8m2!3d28.69439!4d-17.78172!16s%2Fg%2F11c5jf_jt1?hl=en&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D">
                Carretera las Nieves, 17, 38700 Santa Cruz de la Palma, Santa
                Cruz de Tenerife, Spain
              </a>
            </p>
          </div>{" "}
        </div>
        <div className="restaurant-link">
          {translation.visitRestaurant}{" "}
          <a href="https://parrillalasnieves.com/">parrillalasnieves.com</a>
        </div>
      </div>
      <div className="footer-downPart">
        <p className="explotaciones">
          EXPLOTACIONES MENDOZA <br />Y RODRÍGUEZ S.L. {currentYear}
        </p>
        <div className="second-line">
          <p className="policy-link">
            <a href="/Policy">Privacy policy</a>
          </p>
          <p className="colaborar">
            <a href="/Contact">{translation.contact}</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
